'use strict';

class IntegracionService {
  constructor($http,apiUrlSiga,DataService,$log) {
    'ngInject';
    this.$http = $http;
    this.apiUrlSiga=apiUrlSiga;
    this.DataService = DataService;
    this.$log=$log;
    
  }
  listaProyectos(){   
    //return this.$http.get(this.apiUrlSiga + `6_listaProyectos`,{params:datos,});
    return this.$http.get(this.apiUrlSiga + `6_listaProyectos`);
  }
  importacionComputosMetricos(dts){  
    this.$log.log('ENTRA AL SERVICIOS=======>') ;
    //this.$log.log(tipo) ;
    //this.$log.log(datos) ;
    //return this.$http.post(this.apiUrlSiga + `10_recepcionarchivocsv/${dts}/${id}/${archivo}`);
    //return this.$http.post(this.apiUrlSiga + `10_recepcionarchivocsv/`,dts,{ responseType: 'arraybuffer' });
    //return this.$http.post(this.apiUrlSiga + `10_recepcionarchivocsv/`,dts,{ responseType: 'json' });
    return this.$http.post(this.apiUrlSiga + `10_recepcionarchivocsv/`,dts);
    
  } 
  eliminaComputosMetricos(id_supervision,id_item){  
    this.$log.log('ENTRA AL SERVICIOS PARA ELIMINAR COMPUTOS METRICOS=======>') ;    
    return this.$http.get(this.apiUrlSiga + `10_eliminar_computos_metricos/${id_supervision}/${id_item}`);
    
  } 
  cambioEstadoProyecto(operacion,id_proyecto,id_usuario,id_rol){  
    this.$log.log('ENTRA AL SERVICIOS PARA CAMBIAR ESTADO A DOCUMENTACION DE LA EMPRESA=======>') ;    
    return this.$http.get(this.apiUrlSiga + `10_cambio_estado_proyecto/${operacion}/${id_proyecto}/${id_usuario}/${id_rol}`);
    
  } 
  registrarPlazoPropuesta(id_proyecto){  
    this.$log.log('ENTRA AL SERVICIOS PARA REGISTRAR PLAZO PROPUESTA=======>') ;    
    return this.$http.get(this.apiUrlSiga + `10_registraPlazoPropuesta/${id_proyecto}`);
    
  } 
  resetMail(dts){  
    this.$log.log('ENTRA AL SERVICIO MAIL=======>') ;    
    //return dts;
    return this.$http.get(this.apiUrlSiga + `6_resetMail`,{ params: dts });
    
  } 
  

  
}

export default IntegracionService;



// WEBPACK FOOTER //
// ./src/app/components/integracion-siga/integracion.service.js